import { defaultIconProps, IconProps } from './IconProps';

export const IconChartBreakoutCircle: import('react').FC<IconProps> = ({ size, color, ...rest }) => {
  const randomId = Math.random().toString(36).slice(2, 15);
  const clipPathId = `clip_${randomId}_icon_chart_breakout_circle`;

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath={clipPathId}>
        <path
          d="M10.3335 2.3335V1.3335M12.9597 3.0406L13.6668 2.3335M13.6737 5.66683H14.6737M14.6339 8.66683C14.2994 12.0357 11.4571 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.54326 3.96461 1.7009 7.3335 1.36641M8.00016 5.3335H10.6668V8.00016M10.4133 5.3335C8.84372 7.55189 6.25774 9.00016 3.3335 9.00016C2.66489 9.00016 2.01397 8.92445 1.38884 8.78114"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

IconChartBreakoutCircle.defaultProps = defaultIconProps;
